module.exports = __webpack_public_path__ + "static/image/help_center_effect_optimization.svg?5304d62bf840e63f40aaf76a71e24e33";